import { Pipe, PipeTransform } from '@angular/core';
import { ISimpleListItem } from '../interfaces/ISimpleListItem';

@Pipe({
    name: 'storeNameById',
    standalone: false
})
export class StoreNameByIdPipe implements PipeTransform {

  public transform(id: number, stores: ISimpleListItem[]): string {
    return stores.find(x => +x.id === id)?.value;
  }
}
